var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93294 2.49997C9.93294 2.08576 10.2687 1.74997 10.6829 1.74997L16.8183 1.74997C17.198 1.74997 17.5622 1.90081 17.8307 2.16931C18.0992 2.43781 18.25 2.80197 18.25 3.18168V16.8158C18.25 17.1955 18.0992 17.5597 17.8307 17.8282C17.5622 18.0967 17.198 18.2475 16.8183 18.2475H10.6829C10.2687 18.2475 9.93294 17.9117 9.93294 17.4975C9.93294 17.0833 10.2687 16.7475 10.6829 16.7475H16.75V3.24997L10.6829 3.24997C10.2687 3.24997 9.93294 2.91418 9.93294 2.49997ZM6.60929 5.88945C6.90218 6.18234 6.90218 6.65721 6.60929 6.95011L4.31066 9.24873L12.0464 9.24873C12.4606 9.24873 12.7964 9.58452 12.7964 9.99873C12.7964 10.4129 12.4606 10.7487 12.0464 10.7487L4.31066 10.7487L6.60929 13.0474C6.90218 13.3403 6.90218 13.8151 6.60929 14.108C6.31639 14.4009 5.84152 14.4009 5.54863 14.108L1.96967 10.5291C1.67678 10.2362 1.67678 9.7613 1.96967 9.4684L5.54863 5.88945C5.84152 5.59655 6.31639 5.59655 6.60929 5.88945Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.2d946e0659264664f7e9c337ea69e545.svg";
export { ForwardRef as ReactComponent };